/*
 * OfferValue Messages
 *
 * This contains all the text for the Offer Value component.
 */
import { defineMessages } from 'react-intl';
import configs from "configs"
import {
  DEPOSIT_RANGE,
  DISTANCE_YEARS_RANGE,
  DURATION_RANGE,
  MONTHLY_RATE_RANGE,
} from 'containers/App/constants';

export const scope = 'app.components.OfferValue';

export default defineMessages({
  brokers: {
    id: `${scope}.brokers`,
    title: 'Provider',
    defaultMessage: "Seleziona il provider",
    errorMessage: `Provider selezionato non valido`,
    name: 'provider',
  },
  products: {
    id: `${scope}.products`,
    title: 'Prodotto',
    defaultMessage: "Seleziona il prodotto",
    errorMessage: `Prodotto selezionato non valido`,
    name: 'product',
  },
  price: {
    id: `${scope}.price`,
    title: 'Canone Mensile',
    defaultMessage: configs.messages[scope].price,
    errorMessage: `Inserisci un valore compreso tra ${MONTHLY_RATE_RANGE.min} e ${MONTHLY_RATE_RANGE.max}`,
    name: 'price',
  },
  deposit: {
    id: `${scope}.deposit`,
    title: 'Anticipo',
    defaultMessage: configs.messages[scope].deposit,
    errorMessage: `Inserisci un valore compreso tra ${DEPOSIT_RANGE.min} e ${DEPOSIT_RANGE.max}`,
    name: 'deposit',
  },
  duration: {
    id: `${scope}.duration`,
    title: 'Durata',
    defaultMessage: 'Seleziona la durata del contratto di Noleggio a Lungo Termine',
    errorMessage: `Inserisci un valore compreso tra ${DURATION_RANGE.min} e ${DURATION_RANGE.max}`,
    name: 'duration',
    unit: 'Mesi',
  },
  distance: {
    id: `${scope}.distance`,
    title: 'Distanza',
    defaultMessage: 'Seleziona il numero di chilometri su base annua',
    errorMessage: `Inserisci un valore compreso tra ${DISTANCE_YEARS_RANGE.min} e ${DISTANCE_YEARS_RANGE.max}`,
    name: 'distance',
    unit: 'Km/Anno',
  },
});
